<template>
<div class="feedback">
      <div @click="centerDialogVisible = true" class="feed-back-buttonSpace">
      <span class="feed-back-btn-icon el-icon-s-order">
        </span>
    <span class="feed-back-btn-desc">文档反馈</span></div>
    <el-dialog
    class="feedback_dialog"
  title="您的改进意见"
  :visible.sync="centerDialogVisible"
  center
  >
  <el-row type="flex" justify="space-between">
     <el-col :span="4">意见反馈</el-col>
     <el-col :span="20">
         <el-input
  type="textarea"
  :autosize="{ minRows: 8, maxRows: 12}"
  placeholder="请输入内容"
  v-model="textarea">
</el-input>
     </el-col>
  </el-row>
  <el-row type="flex" justify="space-between">
     <el-col :span="4">问题类型</el-col>
     <el-col :span="20">
        <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="(item,index) in checkboxList" :key="index" :label="item.key">{{item.value}}</el-checkbox>
        </el-checkbox-group>
     </el-col>
  </el-row>
   <el-row type="flex" justify="space-between">
     <el-col :span="4">标记内容</el-col>
     <el-col :span="20" style="height: 195px;overflow-y: auto;" >
          <el-checkbox v-model="radio">附上文章内容截图，标记具体内容帮助我们完善文档</el-checkbox>
        <el-upload
        v-show="radio"
        action="/api/upload/"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :limit="5"
        accept=".jpg,.png"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :on-success="uploadSuccess"
        >
        <i class="el-icon-plus"></i>
        </el-upload>

     </el-col>
  </el-row>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="submit">完成并提交</el-button>
  </span>
</el-dialog>
<el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
</div>

</template>

<script>
export default {
    name:"Feedback",
    data() {
        return {
            upfile:[],
            pid:15,
            dialogImageUrl: '',
            dialogVisible:false,
            centerDialogVisible : false,
            textarea: '',
            checkList: [],
            keywords:"",
            seconds: 1,
            fileshows:[],
            fileList: [
                // {
                //   name: "food.jpeg",
                //   url:
                //     "http://localhost:3099/mxchmfile/1607937883484-kehu.png",
                // },
                // {
                //   name: "food2.jpeg",
                //   url:
                //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
                // },
            ],
            checkboxList: [
                {
                    key:"内容找不到",
                    value:"内容找不到"
                },
                {
                    key:"内容没更新",
                    value:"内容没更新"
                },
                {
                    key:"描述不清楚",
                    value:"描述不清楚"
                },
                {
                    key:"链接有错误",
                    value:"链接有错误"
                },
                {
                    key:"步骤不完整",
                    value:"步骤不完整"
                },
                {
                    key:"代码/图片缺失",
                    value:"代码/图片缺失"
                }

            ],
            radio: true,
              dialogImageUrl: '',

        }
    },
    mounted:function(){
        this.get(this.pid, this.keywords);
    },
    methods: {
          async get(pid, keywords) {
          var that = this;
          that.pid =pid;


      // this.msg=res.body.data;
    },

     handleRemove(file, fileList) {
        //移除已上传的图片
          var that = this;
          for (var i in that.fileList) {
	            	for (var k in that.fileList[i]) {
	                   if (that.fileList[i][k] == file.uid) {
                      var index = that.fileList.indexOf(that.fileList[i]);
                      if (index > -1) {
                      that.fileList.splice(index, 1);
                      }
	                    break;
	                	}
	            	}
	      		}
      },
      handlePictureCardPreview(file) {
        //放大图片
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    uploadSuccess(response, file, fileList){
            //console.log(response,file,fileList)
            var that = this;
            let files = {name:response.name,url:response.url};
            // let len = that.fileList.length;
            // that.fileList[len] = files;
      			that.fileList.push(files);
      		},
    //  beforeUpload() {
    //   var that = this;
    //   const file = that.$refs.upload.uploadFiles[0];
    //   const formData = new FormData();
    //   const headerConfig = {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   };
    //   if (!file) {
    //     // 若未选择文件
    //     alert("请选择文件");
    //     return;
    //   }
    //   formData.append("file", file.raw);
    //   that.$api.post("/upload", formData, headerConfig).then(
    //     (res) => {
    //       that.upfile.push(file);
    //       let fileObj = {name:res.data.name,url:res.data.url};
    //       let len = that.fileList.length;
    //       console.log(len,'len')
    //       that.fileList[len] = fileObj
    //       console.log(that.fileList,'len')
    //       //that.fileList.push(fileObj)
    //     },
    //     (res) => {
    //       that.$message.error("服务器异常，请稍后重试！");
    //     }
    //   );
    // },

      submit(){
//提交建议
      var that = this;
      var pid = that.pid;
      var account = that.textarea;
      var type = that.checkList.join();
      var file = JSON.stringify(that.fileList);
      //console.log(file);return;
      if (
        !account ||!file||!type
      ) {
        that.$message({
          message: "请先完善信息！",
          type: "warning",
        });
        return;
      }
      that.$api
        .post("/suggestion", {
          pid:pid,
          account: account,
          file: file,
          type: type,
        })
        .then(
          function (res) {
            if (res.data.code == "success") {
               that.$message({
                message: '感谢您的建议！我们将努力做到更好',
                type: 'success'
               });

               that.centerDialogVisible = true;
                var interval = setInterval(() => {
                that.seconds--;
                if (that.seconds <= 0) {
                  that.centerDialogVisible = false;
                  clearInterval(interval);
                }
                }, 1000);
                that.seconds = 1;


              //  setTimeout(that.centerDialogVisible = false, 10000);
               //that.centerDialogVisible = false;
            }else {
              that.$message({
                message: res.data.msg,
                type: "warning",
              });
              return;
            }
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
      }

    },
}
</script>

<style>
.feed-back-buttonSpace {
    z-index: 999;
    bottom: 15%;
    right: 8px;
    margin: 0;
    padding: 0;
    position: fixed;
    right: 10px;
    background: #f9f9f9;
    bottom: 200px;
    padding-top: 12px;
    padding-bottom: 12px;
    border-color: #02A3FF;
    width: 44px;
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: #e1e8f0;
    text-align: center;
    cursor: pointer;
    color: #00a4ff;
}
.feed-back-buttonSpace .feed-back-btn-desc {
    display: block;
    text-align: center;
    width: 16px;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    line-height: 1;
    margin-top: 8px;
}
.feedback .feed-back-btn-icon {
    font-size: 25px;
}
.feedback .el-dialog__header {
display: flex;
justify-content: space-between;
}
.feedback .el-dialog__title {
    font-size: 16px;
}
.feedback_dialog .el-dialog {
    width:40%;

    }
.feedback_dialog .el-checkbox__label {
    display: inline;
    white-space: initial;
}
.feedback_dialog .el-row {
    margin-bottom:10px ;
}
@media screen and (max-width: 1220px) {
  .feedback_dialog .el-dialog {
    width:70%;

    }
}
@media screen and (max-width: 760px) {
  .feedback_dialog .el-dialog {
    width:90%;

    }
}
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue